import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useTypedSelector } from '../../../../../hooks';
import { priceAsString } from '../../../../../utils/price';
import { getPriceStructure, getProductPaymentAmount, getStopSituation } from '../../../ducks';
import { TermsBlock } from './TermsBlock';
import { TermsPrice } from './TermsPrice';
import { translate } from '../../../../../utils/localization';

export const TermsBlockType = (): JSX.Element => {
  const situation = useTypedSelector(state => getStopSituation(state, 'pickup'));
  const priceStructure = useTypedSelector(getPriceStructure);
  const productPaymentAmount = useTypedSelector(getProductPaymentAmount);
  const transportTypeCharge = priceStructure?.pickup?.find(item => item.charge === 'situation');
  const auctionType = useTypedSelector(state => state.generalTransport.choices?.auction_type);
  const homeSituation = useTypedSelector(state => state.generalTransport.choices?.home_situation);

  let choice = '';
  if (situation === 'home')
    choice = translate(`request_flow.home_situation.fields.type.options.${homeSituation}.title`) || '';
  if (situation === 'auction')
    choice = (auctionType === 'others' ? translate('request_flow.situation.other') : auctionType) || '';

  return (
    <div className={'pt-[1em]'}>
      <TermsBlock
        title={<Translate id="request_flow.terms.block_heading.transport_type" />}
        borderRadius="top"
        border="bottom"
        titleClassName="main-title"
      />

      <TermsBlock title={<Translate id={`request_flow.situation.${situation}`} />} borderRadius="bottom">
        <div className="flex justify-between">
          <div className="first:capitalize">{choice}</div>
          {transportTypeCharge && <TermsPrice price={transportTypeCharge.price} />}
        </div>
        {productPaymentAmount && (
          <div className="flex justify-between">
            <div>
              <Translate id="request_flow.terms.product_payment" />
            </div>
            <div style={{ fontSize: '16px' }}>
              {priceAsString({
                price: { currency: 'EUR', amount: productPaymentAmount },
                addPlusMinusIndicator: false,
                withDoubleZeroes: true,
              })}
            </div>
          </div>
        )}
      </TermsBlock>
    </div>
  );
};
